module.exports = __webpack_public_path__ + "img/saishianpai-icon-0.08553b69.png";